<script>
    export let values = [];
    export let value;

</script>

<div class="btn-group btn-group-xs ">
    {#each values as v}
         <label tabindex="0" on:keydown={(e)=> {if (e.keyCode===13) value = v.val}} class="btn btn-default" class:active="{value === v.val}" title="{v.title}"><input type="radio" bind:group={value} value={v.val}><i class="fas {v.icon} {v.val}"></i></label>
    {/each}
</div>